module.exports = __webpack_public_path__ + "img/placeholder.c05dea51.jpg";